import React from "react";
import { UserFormState_toUserRequest } from "../../../types/forms/UserFormState";
import { CreateUserFormProps } from ".";
import { createUserAsync } from "../../../apiClient";
import { showDangerAlert } from "../../../common";
import useUserForm from "../useUserForm";

function useCreateUserForm(props: CreateUserFormProps) {
  const baseFormContent = useUserForm({
    resources: props.resources,
    showNewUserRoleRowDefault: true,
  });

  function handlePasswordChange(newValue: string) {
    baseFormContent.setFormState((prev) => ({
      ...prev,
      password: { value: newValue, errorMessage: undefined },
    }));
  }

  function handleConfirmationPasswordChange(newValue: string) {
    baseFormContent.setFormState((prev) => ({
      ...prev,
      confirmationPassword: { value: newValue, errorMessage: undefined },
    }));
  }

  async function handleSubmitAsync(e: React.FormEvent) {
    e.preventDefault();

    if (
      baseFormContent.formState.password.value !==
      baseFormContent.formState.confirmationPassword.value
    ) {
      baseFormContent.setFormState((prev) => ({
        ...prev,
        password: { value: "", errorMessage: undefined },
        confirmationPassword: {
          value: "",
          errorMessage: props.resources.get("PasswordMissmatchError"),
        },
      }));
      return;
    }

    const request = UserFormState_toUserRequest(baseFormContent.formState);
    const result = await createUserAsync(request);

    if (result.failed) {
      const errors = result.error.errors;
      const hasMappedErrors = Object.keys(baseFormContent.formState).some(
        (key) => {
          const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
          return (errors?.[pascalKey]?.length ?? 0) > 0;
        },
      );

      if (hasMappedErrors) {
        baseFormContent.setFormState((prev) => ({
          ...prev,
          firstName: {
            ...prev.firstName,
            errorMessage: errors["FirstName"]?.[0],
          },
          lastName: { ...prev.lastName, errorMessage: errors["LastName"]?.[0] },
          email: { ...prev.email, errorMessage: errors["Email"]?.[0] },
          phoneNumber: {
            ...prev.phoneNumber,
            errorMessage: errors["PhoneNumber"]?.[0],
          },
          password: { value: "", errorMessage: errors["Password"]?.[0] },
          confirmationPassword: {
            value: "",
            errorMessage: errors["ConfirmationPassword"]?.[0],
          },
          companyId: {
            ...prev.companyId,
            errorMessage: errors["CompanyId"]?.[0],
          },
          newCompanyName: {
            ...prev.newCompanyName,
            errorMessage: errors["NewCompanyName"]?.[0],
          },
          roles: { ...prev.roles, errorMessage: errors["Roles"]?.[0] },
        }));
      } else {
        showDangerAlert(
          props.resources.get("CreateUserError") ?? result.error.title,
        );
      }
      return;
    }

    window.location.href = "/Users";
  }

  return {
    ...baseFormContent,
    isLoading: baseFormContent.isLoadingCompanyOptions,
    handlePasswordChange,
    handleConfirmationPasswordChange,
    handleSubmitAsync,
  };
}

export default useCreateUserForm;
